import instance from "../auth/authApi";

export interface ExclusionZoneDTO {
  id: number;
  tenantId: string;
  name: string;
  active: boolean;
  streetLabel: string;
  postalCode: string;
  locality: string | null;
  startNumber: number;
  endNumber: number;
  startPlaceId: string;
  endPlaceId: string;
  startAddress: string;
  endAddress: string;
  updatedByEmail: string | null;
  updatedAt: string;
}

export interface ExclusionZonePayload {
  tenantId?: string;
  name: string;
  startPlaceId: string;
  endPlaceId: string;
  active: boolean;
}

export interface ExclusionZoneCheckDTO {
  excluded: boolean;
  message?: string;
  zone?: { id: number; name: string };
}

/** Message d'erreur renvoyé par l'API (validation, droits), sinon message générique. */
export function getExclusionZoneApiErrorMessage(error: any, fallback: string): string {
  const message = error?.response?.data?.message;
  return typeof message === "string" && message !== "" ? message : fallback;
}

export async function getExclusionZones(tenantId?: string): Promise<ExclusionZoneDTO[]> {
  const response = await instance.get(`/exclusion-zones`, { params: { tenantId } });
  return response.data.zones;
}

export async function createExclusionZone(payload: ExclusionZonePayload): Promise<ExclusionZoneDTO> {
  const response = await instance.post(`/exclusion-zones`, payload);
  return response.data.zone;
}

export async function updateExclusionZone(id: number, payload: ExclusionZonePayload): Promise<ExclusionZoneDTO> {
  const response = await instance.put(`/exclusion-zones/${id}`, payload);
  return response.data.zone;
}

export async function setExclusionZoneActive(id: number, active: boolean, tenantId?: string): Promise<ExclusionZoneDTO> {
  const response = await instance.patch(`/exclusion-zones/${id}`, { active, tenantId });
  return response.data.zone;
}

export async function deleteExclusionZone(id: number, tenantId?: string): Promise<void> {
  await instance.delete(`/exclusion-zones/${id}`, { params: { tenantId } });
}

export async function checkExclusionZone(
  params: ({ placeId: string } | { lat: number; lng: number }) & { tenantId: string },
): Promise<ExclusionZoneCheckDTO> {
  const response = await instance.get(`/exclusion-zones/check`, { params });
  return response.data;
}
